import { Icon, MenuOption, typography } from '@joor/design-system'
import styled from 'styled-components/macro'

import { DateQuickFilterType } from './DateMenuOptions'

export function DateQuickFilterOption({
  label,
  type,
  isSelected,
  handleClick,
}: Props) {
  return (
    <StyledMenuOption
      key={type}
      onClick={() =>
        handleClick({
          type,
          isSelected,
        })
      }
    >
      <OptionContainer className={isSelected ? 'selected' : ''}>
        {label}
        <Icon
          iconName="checkmark"
          iconSize="small"
          data-testid="checkmark-icon"
        />
      </OptionContainer>
    </StyledMenuOption>
  )
}

type Props = {
  label: string
  type: DateQuickFilterType
  isSelected: boolean
  handleClick: (props: {
    type: DateQuickFilterType
    isSelected: boolean
  }) => void
}

const StyledMenuOption = styled(MenuOption)`
  & > div:first-child {
    width: 100%;
  }

  svg {
    display: none;
  }
`

const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  width: 100%;

  svg {
    display: block;
    visibility: hidden;
  }

  &.selected {
    ${typography.alpha.primaryActive.body2}
    color: var(--color-secondary-800);

    svg {
      visibility: visible;
      --main-color: var(--color-secondary-800);
    }
  }
`
